/* __next_internal_client_entry_do_not_use__ TileGridError auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { errorComponent } from "@faire/retailer-visitor-shared/app/(app)/visitor/[locale]/(pagesWithModal)/(defaultHeader)/brand/[brandToken]/(rsc)/rsc/_sections/ProductTiles/styles.css";
import { Caution } from "@faire/web--source/slate/icons/foundation/Caution";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var TileGridError = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        className: errorComponent,
        children: [
            /*#__PURE__*/ _jsx(Caution, {
                color: Core.icon.subdued,
                fontSize: "24px"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "bY8DY1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "An error has occurred, please try again."
                        }
                    ]
                })
            })
        ]
    });
};
